import { render, staticRenderFns } from "./HeaderBtns.vue?vue&type=template&id=311b46f2&scoped=true&"
import script from "./HeaderBtns.vue?vue&type=script&lang=js&"
export * from "./HeaderBtns.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBtns.vue?vue&type=style&index=0&id=311b46f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b46f2",
  null
  
)

export default component.exports